// Guide library (§11 / §13). Free guides are email-gated but also have a public
// indexable HTML page (AEO win). Paid guides are purchasable (payments deferred).

export const GUIDES = [
  {
    slug: "china-sourcing-atlas",
    title: "The China Sourcing Atlas",
    tag: "free",
    filters: ["free", "china"],
    blurb: "25 markets, 12 specialty towns, Yiwu district by district — 11 pages.",
    country: "China",
    toc: ["The 25 markets that matter", "12 specialty towns", "Yiwu district by district", "How to trip-stack a buying visit"],
    summary:
      "The China Sourcing Atlas maps 25 wholesale markets and 12 specialty manufacturing towns across China, with a district-by-district breakdown of Yiwu. It is written for importers planning a buying trip who want to know exactly which market makes their product before they book a flight.",
  },
  {
    slug: "india-sourcing-atlas",
    title: "India Sourcing Atlas & Almanac",
    tag: "free",
    filters: ["free", "india"],
    blurb: "24 clusters across 4 regions + 12 Indian fairs. For global buyers.",
    country: "India",
    toc: ["24 manufacturing clusters", "4 regions compared", "12 Indian trade fairs", "Export-house vetting basics"],
    summary:
      "The India Sourcing Atlas & Almanac profiles 24 manufacturing clusters across four regions and lists 12 Indian trade fairs. It helps global buyers understand where India is genuinely competitive — textiles, handicrafts, fasteners, leather — and how to vet an export house.",
  },
  {
    slug: "china-trade-fair-almanac",
    title: "China Trade Fair Almanac",
    tag: "free",
    filters: ["free", "china", "fairs"],
    blurb: "Every major Chinese fair, month by month, with trip-stacking routes.",
    country: "China",
    toc: ["Fair calendar, month by month", "Canton Fair phases explained", "Trip-stacking routes", "What to prepare before you go"],
    summary:
      "The China Trade Fair Almanac lists every major Chinese trade fair month by month, explains the three Canton Fair phases, and suggests routes to stack multiple fairs and markets into one efficient trip.",
  },
  {
    slug: "global-trade-fair-almanac",
    title: "Global Trade Fair Almanac",
    tag: "free",
    filters: ["free", "fairs"],
    blurb: "50+ world fairs tagged buyer / exhibitor / trend, plus an India corner.",
    country: "Global",
    toc: ["50+ world fairs", "Buyer vs exhibitor vs trend tags", "Regional highlights", "India corner"],
    summary:
      "The Global Trade Fair Almanac catalogues more than 50 international trade fairs, tagged by whether they suit buyers, exhibitors or trend-scouting, with a dedicated India corner for global buyers.",
  },
  {
    slug: "canton-fair-field-manual",
    title: "Canton Fair Field Manual",
    tag: "paid",
    price_inr: 1499,
    price_usd: 19,
    filters: ["paid", "china", "fairs"],
    blurb: "All 3 phases, hall plans, negotiation scripts, phrases, money rules. Phone-sized.",
    country: "China",
    toc: ["All three phases mapped", "Hall plans", "Negotiation scripts and phrases", "Money and payment rules"],
    summary:
      "The Canton Fair Field Manual is a phone-sized companion covering all three phases, hall plans, negotiation scripts, useful phrases and money rules — designed to be read on the fair floor.",
  },
  {
    slug: "verification-toolkit",
    title: "The Verification Toolkit",
    tag: "paid",
    price_inr: null,
    price_usd: null,
    soon: true,
    filters: ["paid"],
    blurb: "Audit forms, RFQ, PI checklist, AQL sheet, bilingual contract templates.",
    country: "Global",
    toc: ["Factory audit forms", "RFQ and PI checklists", "AQL inspection sheet", "Bilingual contract templates"],
    summary:
      "The Verification Toolkit bundles factory audit forms, RFQ and proforma-invoice checklists, an AQL inspection sheet and bilingual contract templates. Coming soon.",
  },
];

export const guideBySlug = (slug) => GUIDES.find((g) => g.slug === slug);
